import React, { useEffect, useMemo, useState } from "react";
import Select from "react-select";
import { DonutChart } from "../components/DonutChart";
import { AdvancedDrilldownGrid } from "../components/AdvancedDrilldownGrid";
import { ImpactSummaryTable } from "../components/ImpactSummaryTable";
import { useLocation, useNavigate } from "react-router-dom";
import RootCauseAnalysisModal from "../components/RootCauseAnalysisModal";
import { apiFetch } from "../apiFetch";
import MetricCard from "../components/MetricCard";
import ReconciliationOverview from "../components/ReconciliationOverview";

export default function RootCauseAnalysis() {
  const navigate = useNavigate();
  const [runs, setRuns] = useState([]);
  const [selectedRun, setSelectedRun] = useState(null);
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [activeFilter, setActiveFilter] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState(null);
  //const [columnOptions, setColumnOptions] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [pagination, setPagination] = useState({});
  const [page, setPage] = useState(1);
  const { state } = useLocation();
  const [drilDownData, setDrilDownData] = useState([])
  const [selectedCategory, setSelectedCategory] = useState("");
  //const [selectedColumn, setSelectedColumn] = useState("");
  const [selectedView, setSelectedView] = useState("");
  const [rowDetails, setRowDetails] = useState(null);   // API response
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedTransformRules,setSelectedTransformRules] =useState([]);
  const [summaryData, setSummaryData] = useState({});
  const categories = drilDownData?.matrix || [];

  const selectedCategoryData = categories.find(
  (c) => c.category === selectedCategory
);

const columnOptions = selectedCategoryData?.columns || [];

/*=========================================================
          FETCH LAST RUNS
 ========================================================= */
  useEffect(() => {
    apiFetch("dashboard/last-compare")
      .then((res) => res.json())
      .then((res) => {
        const sorted = res.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        console.log("STATE***********",JSON.stringify(state));
        setRuns(sorted);
        if(state?.file_mapping_id){
          setSelectedRun(sorted.find(s=>(s.file_mapping_id==state.file_mapping_id && s.id==state.id)));
        }else{
          setSelectedRun(sorted[0])
        }
      })
      .catch(setError);
  }, []);

  /*=========================================================
            FETCH SUMMARY DETAILS FOR SELECTED RUN
  ============================================================*/
  useEffect(()=>{
    if(selectedRun){
      try {
        apiFetch( "file-mapping-config/summary-details",{
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          
          body: JSON.stringify({
            configId: selectedRun.file_mapping_id,
            uploadedFileId: selectedRun.id,
          }),
        })
        .then((res) => res.json())
        .then((data) => { 
         
          let response = data.data;
          response['matched'] = response?.matchedCount;
          response['unmatched'] = response?.missMatchedCount;
          response['matchRate'] = response?.accuracy.toFixed(2);
          setSummaryData(response)
          //setFilePath(response.file_path);
         
        }
        )
        .catch((err) => console.error(err));
        
      } catch (err) {
        console.error(err);
      } finally {
        // setRunning(false);
      }
      
    }

  },[selectedRun])

  /* ========================================================== 
              FETCH DRILLDOWN
  ============================================================*/
  useEffect(() => {
    if (!selectedRun) return;

    setLoading(true);
    setError(null);

    apiFetch(
    
        "file-mapping-config/drildown-details",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          configId: selectedRun.file_mapping_id,
          uploadedFileId: selectedRun.id,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => setDrilDownData(res.data || {}))
      .catch(setError)
      .finally(() => setLoading(false));
  }, [selectedRun]);

  /* =========================================================== 
              DROPDOWN GROUPING
    ============================================================*/

  const groupedOptions = useMemo(() => {
    return Object.values(
      runs.reduce((acc, run) => {
        if (!acc[run.config_name]) {
          acc[run.config_name] = {
            label: run.config_name,
            options: [],
          };
        }

        acc[run.config_name].options.push({
          value: run.id,
          label: `${new Date(run.created_at).toLocaleString()} | ${
            run.accuracy
          }% ${run.status ? "✅" : "❌"}`,
          fullData: run,
        });

        return acc;
      }, {})
    );
  }, [runs]);

  /* ==================================================
              CHART DATA
  ================================================== */
  const chartData = [
    { name: "Input", value: data.inputPercentage || 0, color: "#005db5" },
    { name: "Custom", value: data.customPercentage || 0 , color: "#cbd5e1"},
    { name: "Formula", value: data.outputPercentage ||0, color: "#5d5c78" },
    { name: "Master", value: data.masterPercentage || 0 ,color: "#9f403d"},
  ];

  /** ================================================== */
    useEffect(() => {
      if (!activeFilter || !data) return;

      let columns = [];

      switch (activeFilter) {
        case "INPUT":
          columns = data.inputColumns || [];
          break;
        case "CUSTOM":
          columns = data.customColumns || [];
          break;
        case "FORMULA":
          columns = data.outputColumns || [];
          break;
        case "MASTER":
          columns = data.masterColumns || [];
          break;
        default:
          columns = [];
      }

      const options = columns.map((col, index) => ({
        value: index,
        label: `${col.source_column} → ${col.target_column}`,
        fullData: col,
      }));

      //setColumnOptions(options);
      setSelectedColumn(null); // reset on filter change
    }, [activeFilter, data]);

  /**================ON COLUMN DROPDOWN SELECTION======================================= */
  
      useEffect(() => {
        console.log(`selectedColumn  ${JSON.stringify(selectedColumn)}`);
      if (!selectedColumn || !selectedRun) return;

      const column = selectedColumn;

      setTableData([])
      setLoading(true);

      apiFetch(
      
          "file-mapping-config/drildown-column-details",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            configId: selectedRun.file_mapping_id,
            uploadedFileId: selectedRun.id,
            sourceColumn: column?.source_column_index,
            targetColumn: column?.target_column_index,
            filterType: activeFilter,
            page,
            limit: 10,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {

          res.data.forEach(element => {
            element["Review"] = `Review`;
          });

         
          setTableData(convertCustomColumnsToBoolean(res.data) || []);
          setPagination(res.pagination || {});
        })
        .catch(setError)
        .finally(() => setLoading(false));
    }, [selectedColumn, page]);
 /**========================================================= */

 function convertCustomColumnsToBoolean(data) {
  return data.map((row) => {
    const updatedRow = { ...row };

    Object.keys(updatedRow).forEach((key) => {
      if (key.startsWith("c_")) {
        const value = updatedRow[key];

        if (value === 1 || value === "1") {
          updatedRow[key] = "FALSE";
        } else if (value === 0 || value === "0") {
          updatedRow[key] = "TRUE";
        }
      }
    });

    return updatedRow;
  });
}
  /* ================= FETCH DRILLDOWN ================= */

  function impactSummaryTableClickHander(data){
    alert(JSON.stringify(data));
    setActiveFilter("INPUT")

  }

  const handleImpactFilter = async () => {

    console.log(selectedCategory,selectedColumn,selectedView );
}; 
  
 /**============================
 * ROW SELECTION
 =================================*/

const handleRowClick = async (row) => {

 
  console.log('handleClick ',JSON.stringify(row));
  
  setSelectedRow(row);     // open panel immediately
  setLoading(true);

  try {
        apiFetch("file-mapping-config/get-transaction-details",{
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
             configId: selectedRun.file_mapping_id,
              uploadedFileId: selectedRun.id,
              transactionId: row.id,
          }),
        })
        .then((res) => res.json())
        .then((data) => { 
          //let esData = data?.data;
          //alert(JSON.stringify(esData))
          setRowDetails(data)
          //console.log(`data ${JSON.stringify(esData[0]?._source)}`);
          
          //setRowDetails(esData[0]?._source);   // full ES response
        }
      )
      .catch((err) => console.error(err));
      
    } catch (err) {
      console.error(err);
      //alert("Process failed");
    } finally {
      setLoading(false);
    }
  
};

/**================================================ */
 // Function To Generate Review Popup table view
/**================================================ */
  const buildComparisonRows = (response) => {

  if (!response?.data?.data?.[0]) return {};

  const item = response.data.data[0];
  const typeConfig = response.type || [];
  const relations = response.relation || [];
  let dependOnColumns = []
  relations.map(
      (r) => r?.dependencies.map(d=>{ dependOnColumns.push(d?.dependencyColumnName.trim().toLowerCase()) })
   );

  const grouped = {};
  //Define group with their order
  grouped['MASTER COLUMN'] = [];
  grouped['INPUT COLUMN'] = [];
  grouped['CUSTOM COLUMN'] = [];
  grouped['OUTPUT COLUMN'] = [];
  grouped['FINAL OUTPUT COLUMN'] = [];

  typeConfig.forEach((t) => {

    const field = t.column_name;
    const group = t.column_type;

    // SOURCE KEY
    const sourceKey = Object.keys(item).find(
      (k) =>
        k.startsWith("s_") &&
        k.replace("s_", "").trim().toLowerCase() ===
          field.trim().toLowerCase()
    );

    // TARGET KEY
    const targetKey = Object.keys(item).find(
      (k) =>
        k.startsWith("t_") &&
        k.replace("t_", "").trim().toLowerCase() ===
          field.trim().toLowerCase()
    );

    // NORMAL COMPARE KEY
    let compareKey = Object.keys(item).find(
      (k) =>
        k.startsWith("c_") &&
        k.replace("c_", "").trim().toLowerCase() ===
          field.trim().toLowerCase()
    );

    // FOR FINAL OUTPUT COLUMN
    let compareValue = compareKey ? item[compareKey] : null;
    if (group === "FINAL OUTPUT COLUMN" && item.final_output) {
        compareValue = item.final_output;
    }
    // RELATION
    const relation = relations.find(
      (r) => r.columnName?.trim().toLowerCase() === field.trim().toLowerCase()
    );

    // ONLY SHOW FALSE
   // if (compareValue === "FALSE") 
      {

      grouped[group].push({
        
        field,

        source: sourceKey
          ? item[sourceKey]
          : "-",

        target: targetKey
          ? item[targetKey]
          : "-",

        match: compareValue,

        dependsOn:
          relation?.dependencies
            ?.sort(
              (a, b) =>
                a.executionOrder -
                b.executionOrder
            )
            ?.map(
              (d) => d.dependencyColumnName
            )
            ?.join(", ") || "-",

        impact:
          relation?.propagationImpact || "-",
        
        isDependOn:dependOnColumns.indexOf(field.trim().toLowerCase())==-1?false:true
      });
    }
  });

  return grouped;
};

  return (

    <div className="bg-gray-50 min-h-screen p-6 font-display text-slate-900 min-h-screen flex flex-col">
      
      {/* MAIN */}
      <main className="flex-1 px-6 md:px-10 py-8 max-w-[1440px] mx-auto w-full">
      {/* =========================================
            PAGE HEADER
        ========================================= */}
        <div className="mb-6">

          <div className="bg-white border border-slate-200 rounded-3xl shadow-sm px-6 py-5">

            <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-6">

              {/* LEFT */}
              <div className="flex items-start gap-4">

                {/* ICON */}
                {/* <div className="w-14 h-14 rounded-2xl bg-blue-100 flex items-center justify-center shrink-0">
                  <span className="material-symbols-outlined text-blue-700 text-3xl">
                    analytics
                  </span>
                </div> */}

                {/* TITLE */}
                <div>

                  <div className="flex items-center gap-3 flex-wrap">

                    <h1 className="text-2xl font-bold tracking-tight text-slate-900">
                      Column Mismatch Analysis
                    </h1>

                    <div className="bg-slate-100 text-slate-600 text-sm font-semibold px-3 py-1 rounded-full">
                      Run #{selectedRun?.id || "N/A"}
                    </div>
                  </div>

                  <p className="text-slate-500 mt-2 text-sm max-w-[700px]">
                    Analyze mismatches column-by-column to identify high impact columns and fields.
                  </p>

                  {/* FILE INFO */}
                  {selectedRun && (
                    <div className="flex flex-wrap gap-2 mt-3">
                        <div className="text-xs font-medium text-slate-700 truncate">
                          Source File : {selectedRun.source_file_name}
                        </div>
                        <div className="text-xs font-medium text-slate-700 truncate">
                         Target File : {selectedRun.target_file_name}
                        </div>

                    </div>
                  )}
                </div>
              </div>

              {/* RIGHT */}
              <div className="flex flex-col items-stretch gap-4 min-w-[420px]">

                {/* SELECT */}
                <Select
                  options={groupedOptions}
                  value={
                    selectedRun
                      ? {
                          value: selectedRun.id,
                          label: `${selectedRun.config_name} • ${new Date(
                            selectedRun.created_at
                          ).toLocaleString()}`,
                        }
                      : null
                  }
                  onChange={(s) => setSelectedRun(s.fullData)}
                  placeholder="Search compare runs..."
                  isSearchable
                  isDisabled={loading}
                  formatGroupLabel={(group) => (
                    <div className="flex items-center justify-between">
                      <span className="font-semibold text-slate-700">
                        {group.label}
                      </span>

                      <span className="bg-blue-100 text-blue-700 text-xs font-bold px-2 py-1 rounded-full">
                        {group.options.length}
                      </span>
                    </div>
                  )}
                  styles={{
                    control: (base, state) => ({
                      ...base,
                      minHeight: "58px",
                      borderRadius: "18px",
                      borderColor: state.isFocused
                        ? "#2563eb"
                        : "#e2e8f0",
                      boxShadow: state.isFocused
                        ? "0 0 0 4px rgba(37,99,235,0.10)"
                        : "none",
                      backgroundColor: "#fff",
                      paddingLeft: "8px",
                      fontSize: "15px",
                      fontWeight: 500,
                    }),

                    valueContainer: (base) => ({
                      ...base,
                      padding: "0 10px",
                    }),

                    placeholder: (base) => ({
                      ...base,
                      color: "#94a3b8",
                    }),

                    singleValue: (base) => ({
                      ...base,
                      color: "#0f172a",
                      fontWeight: 600,
                    }),

                    menu: (base) => ({
                      ...base,
                      borderRadius: "20px",
                      overflow: "hidden",
                      border: "1px solid #e2e8f0",
                      boxShadow:
                        "0 20px 40px rgba(15,23,42,0.10)",
                      zIndex: 9999,
                    }),

                    menuList: (base) => ({
                      ...base,
                      padding: "10px",
                    }),

                    option: (base, state) => ({
                      ...base,
                      borderRadius: "14px",
                      marginBottom: "6px",
                      padding: "14px",
                      backgroundColor: state.isSelected
                        ? "#2563eb"
                        : state.isFocused
                        ? "#eff6ff"
                        : "#fff",
                      color: state.isSelected
                        ? "#fff"
                        : "#0f172a",
                      cursor: "pointer",
                      fontWeight: 500,
                    }),

                    groupHeading: (base) => ({
                      ...base,
                      fontSize: "12px",
                      fontWeight: 700,
                      color: "#64748b",
                      textTransform: "uppercase",
                      padding: "10px 12px",
                      background: "#f8fafc",
                      borderRadius: "12px",
                      marginBottom: "8px",
                    }),
                  }}
                  filterOption={(option, inputValue) => {
                    const search = inputValue.toLowerCase();

                    return (
                      option.label
                        .toLowerCase()
                        .includes(search) ||
                      option.data.fullData?.config_name
                        ?.toLowerCase()
                        ?.includes(search)
                    );
                  }}
                />

                {/* SUMMARY */}
                <div className="grid grid-cols-1 gap-3">

                  {/* <div className="bg-gradient-to-br from-red-50 to-red-100 border border-red-200 rounded-2xl px-5 py-4">
                    <div className="text-xs uppercase font-bold tracking-wide text-red-500">
                      Mismatches
                    </div>

                    <div className="text-3xl font-bold text-red-600 mt-2">
                      {summaryData?.missMatchedCount || 0}
                    </div>
                  </div> */}

                  {/* <div className="bg-gradient-to-br from-blue-50 to-blue-100 border border-blue-200 rounded-2xl px-5 py-4">
                    <div className="text-xs uppercase font-bold tracking-wide text-blue-500">
                      Accuracy
                    </div>

                    <div className="text-3xl font-bold text-blue-700 mt-2">
                      {selectedRun?.accuracy?.toFixed(2) || 0}%
                    </div>
                  </div> */}

                </div>
              </div>
            </div>
          </div>
        </div>
        {/* =========================================
            ERROR
        ========================================= */}
        {error && (
          <div className="mb-4 bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-2xl">
            Failed to load analysis data
          </div>
        )}
        {/* =========================================
            SUMMARY CARD VIEW
        ========================================= */}
        <div className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm">
        {/* <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-8 gap-4">
            <MetricCard title="Matched" value={summaryData?.matchedCount}  desc = "Transactions" color="text-emerald-600" bg="bg-emerald-50" />
            <MetricCard title="Unmatched" value={summaryData?.missMatchedCount}  desc = "Transactions" color="text-rose-600" bg="bg-rose-50" />
            <MetricCard title="Source Unique" value={summaryData?.sourceUniqueCount}  desc = "Transactions" color="text-slate-700" bg="bg-slate-100"/>
            <MetricCard title="Target Unique" value={summaryData?.targetUniqueCount}  desc = "Transactions" color="text-slate-700" bg="bg-slate-100"/>
            <MetricCard title="Source Only" value={summaryData?.sourceOnlyCount}  desc = "Transactions" color="text-amber-600" bg="bg-amber-50" />
            <MetricCard title="Target Only" value={summaryData?.targetOnlyCount}  desc = "Transactions" color="text-rose-600" bg="bg-rose-50" />
            <MetricCard title="Source" value={summaryData?.sourceInvoiceCount}  desc = "Payment Party" color="text-amber-600" bg="bg-amber-50" />
            <MetricCard title="Target" value={summaryData?.targetInvoiceCount} desc = "Payment Party" color="text-rose-600" bg="bg-rose-50"/>
          </div> */}
          <ReconciliationOverview stats={{
                              total: summaryData?.sourceUniqueCount,
                              matched: summaryData?.matchedCount,
                              unmatched: summaryData?.missMatchedCount,
                              sourceOnly: summaryData?.sourceOnlyCount,
                              targetOnly: summaryData?.targetOnlyCount,
                              sourceRecords: summaryData?.sourceUniqueCount,
                              targetRecords: summaryData?.targetUniqueCount,
                              sourceParty: summaryData?.sourceInvoiceCount,
                              targetParty: summaryData?.targetInvoiceCount
                            }}></ReconciliationOverview>
        </div>

      {/* ================= CHART + CARDS ================= */}
      <div className="grid grid-cols-[320px_1fr] gap-6 mt-6">

            {/* =========================================
                LEFT DRAWER
            ========================================== */}
            <div className="bg-white rounded-2xl border shadow-sm h-[calc(100vh-180px)] overflow-y-auto">

              <div className="p-4 border-b sticky top-0 bg-white z-10">
                <h2 className="text-lg font-bold text-slate-800">
                  Impact Analysis
                </h2>

                <p className="text-sm text-slate-500 mt-1">
                  Drill into mismatched columns
                </p>
              </div>

              <div className="p-2">

                {categories.map((category, idx) => {

                  const sortedColumns = [...category.columns].sort(
                    (a, b) => b.unmatched_count - a.unmatched_count
                  );

                  const isOpen = selectedCategory === category.category;

                  return (
                    <div
                      key={idx}
                      className="mb-2 border rounded-xl overflow-hidden"
                    >

                      {/* CATEGORY HEADER */}
                      <button
                        onClick={() =>
                          setSelectedCategory(
                            isOpen ? "" : category.category
                          )
                        }
                        className={`w-full flex items-center justify-between px-4 py-3 transition
                          ${
                            isOpen
                              ? "bg-blue-50"
                              : "hover:bg-slate-50"
                          }`}
                      >
                        <div className="text-left">
                          <div className="font-semibold text-slate-800">
                            {category.category}
                          </div>

                          <div className="text-xs text-slate-500 mt-1">
                            {category.columnCount} Columns
                          </div>
                        </div>

                        <div className="flex items-center gap-2">
                          {category.transactionCount> 0 ?
                          (<><div className="bg-red-100 text-red-600 text-xs font-bold px-2 py-1 rounded-full">
                              {category.transactionCount}
                            </div>
                            <span className="text-slate-400">
                              {isOpen ? "−" : "+"}
                            </span></>
                          ):
                          (
                            <div className="bg-green-100 text-green-600 text-xs font-bold px-2 py-1 rounded-full">
                              {category.transactionCount}
                            </div>
                          
                          )}
                        </div>
                      </button>

                      {/* COLUMN LIST */}
                      {isOpen && (
                        <div className="border-t bg-slate-50">

                          {sortedColumns.length === 0 ? (
                            <div className="p-4 text-sm text-slate-400">
                              No columns available
                            </div>
                          ) : (
                            sortedColumns.map((col, cidx) => {

                              const active =
                                selectedColumn?.target_column ===
                                col.target_column;

                              return (
                                <button
                                  key={cidx}
                                  onClick={() => {
                                    setSelectedColumn(col);
                                    setPage(1);
                                  }}
                                  className={`w-full px-4 py-3 flex items-center justify-between text-left border-b last:border-b-0 transition
                                    ${
                                      active
                                        ? "bg-blue-100"
                                        : "hover:bg-white"
                                    }`}
                                >

                                  <div className="pr-2">
                                    <div className="font-medium text-sm text-slate-700">
                                      {col.target_column}
                                    </div>

                                    <div className="text-xs text-slate-400 mt-1">
                                      {col.source_column}
                                    </div>
                                  </div>

                                  <div
                                    className={`min-w-[32px] h-7 px-2 rounded-full flex items-center justify-center text-xs font-bold
                                      ${
                                        col.unmatched_count > 0
                                          ? "bg-red-100 text-red-600"
                                          : "bg-green-100 text-green-600"
                                      }`}
                                  >
                                    {col.unmatched_count}
                                  </div>
                                </button>
                              );
                            })
                          )}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* =========================================
                RIGHT CONTENT
            ========================================== */}
            <div className="space-y-4">

              {/* SELECTED FILTER INFO */}
              {selectedColumn && (
                <div className="bg-white border rounded-2xl p-5 shadow-sm">

                  <div className="flex items-center justify-between">

                    <div>
                      <h2 className="text-xl font-bold text-slate-800">
                        {selectedColumn.target_column}
                      </h2>

                      <div className="text-sm text-slate-500 mt-1">
                        Source: {selectedColumn.source_column}
                      </div>
                    </div>

                    <div className="flex gap-3">

                      <div className="bg-red-50 text-red-600 px-4 py-2 rounded-xl">
                        <div className="text-xs uppercase font-semibold">
                          Mismatches
                        </div>

                        <div className="text-xl font-bold">
                          {selectedColumn.unmatched_count}
                        </div>
                      </div>

                      <div className="bg-slate-100 px-4 py-2 rounded-xl">
                        <div className="text-xs uppercase font-semibold text-slate-500">
                          Diff
                        </div>

                        <div className="text-xl font-bold text-slate-700">
                          {selectedColumn.allowed_diff}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              )}

              {/* TABLE */}
              <div className="bg-white rounded-2xl border shadow-sm p-4">

                <AdvancedDrilldownGrid
                  data={tableData}
                  loading={loading}
                  
                  onCellClick={({ row, column, value }) => {
                    console.log("Column:", column);
                    console.log("Value:", value);
                    console.log("Row:", row);
                    if(column=="Review"){
                      row.id = row.transaction_id;
                      handleRowClick(row);
                    }
                  }}
                />

                {/* PAGINATION */}
                <div className="flex justify-between items-center mt-5">

                  <div className="text-sm text-slate-500">
                    Page {pagination.page || 1} of{" "}
                    {pagination.totalPages || 1}
                  </div>

                  <div className="flex gap-2">

                    <button
                      disabled={page === 1}
                      onClick={() => setPage(page - 1)}
                      className="px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 disabled:opacity-40"
                    >
                      Prev
                    </button>

                    <button
                      disabled={page === pagination.totalPages}
                      onClick={() => setPage(page + 1)}
                      className="px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 disabled:opacity-40"
                    >
                      Next
                    </button>

                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* REVIEW POPUP */}
        
          <RootCauseAnalysisModal
            configId={selectedRun?.file_mapping_id}
            open={!!selectedRow}
            loading={loading}
            rowDetails={rowDetails}
            transactionId={selectedRow?.id}
            onClose={() => {
              setSelectedRow(null);
              setRowDetails(null);
            }}
             onRulesChange={
                  setSelectedTransformRules
              }
          />
                   

        
      </main>
    </div>

  );
}

/* ================= COMPONENTS ================= */

const SummaryCards = ({ summary }) => (
  <div className="flex gap-3">
    <div className="bg-gray-100 px-4 py-2 rounded-xl text-right">
      <div className="text-xs text-gray-500">Mismatches</div>
      <div className="text-2xl font-bold text-red-600">
        {summary?.mismatched || 0}
      </div>
    </div>

    <div className="bg-gray-100 px-4 py-2 rounded-xl text-right">
      <div className="text-xs text-gray-500">Accuracy</div>
      <div className="text-2xl font-bold text-blue-600">
        {summary?.accuracy?.toFixed(2) || 0}%
      </div>
    </div>
  </div>
);

const Card = ({ title, desc, percent, icon,onClick }) => (
  <div  onClick={onClick} className="bg-white p-6 rounded-xl shadow hover:scale-[1.02] cursor-pointer transition">
    <div className="flex justify-between items-start mb-4">
      <div className="p-3 bg-blue-100 rounded-lg">
        <span className="material-symbols-outlined text-blue-600 text-xl">
          {icon}
        </span>
      </div>

      <div className="flex flex-col items-end">
        <span className="text-[10px] font-bold text-gray-500 uppercase">
          Impact Prob.
        </span>
        <span className="font-bold text-blue-600">
          {percent ? percent.toFixed(2) + "%" : "NA"}
        </span>
      </div>
    </div>

    <h4 className="font-bold text-gray-800 text-lg mb-1">{title}</h4>
    <p className="text-sm text-gray-500">{desc}</p>
  </div>
);

/**========================================================
 *  DATA TABLE
 ===========================================================*/
const Table = ({ data, pagination, page, setPage }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow p-4">
        No data available
      </div>
    );
  }

  //  Extract dynamic columns
  const columns = Object.keys(data[0]);

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <h3 className="font-bold mb-4">Records</h3>

      <div className="overflow-auto">
        <table className="min-w-full text-sm border">
          <thead className="bg-gray-100">
            <tr>
              {columns.map((col) => (
                <th key={col} className="p-2 border text-left">
                  {col}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row, i) => (
              <tr key={i} className="hover:bg-gray-50">
                {columns.map((col) => {
                  const value = row[col];

                  //  Highlight mismatch column
                  const isCheckColumn = col.startsWith("c_");

                  return (
                    <td
                      key={col}
                      className={`p-2 border ${
                        isCheckColumn && value === "FALSE"
                          ? "bg-red-100 text-red-600 font-semibold"
                          : ""
                      }`}
                    >
                      {value}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/*  Pagination */}
      <div className="flex justify-between items-center mt-4">
        <div className="text-sm text-gray-500">
          Page {pagination.page} of {pagination.totalPages}
        </div>

        <div className="flex gap-2">
          <button
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Prev
          </button>

          <button
            disabled={page === pagination.totalPages}
            onClick={() => setPage(page + 1)}
            className="px-3 py-1 bg-gray-200 rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};


